import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';

import {
  orderPrintingConfigAnalytic,
  orderPrintingConfigService,
} from '../infra';
import { useOrderPrintingConfigLang } from './useOrderPrintingConfigLang';

import type { PartnerId } from 'business/shared/domain';

const INIT_STATE = { command: false, checklist: false, autoPrint: false };

export function useOrderPrintingConfig() {
  const [_state, _setState] = useState(INIT_STATE);

  const {
    getOrderPrintingConfig,
    setOrderPrintingConfig,
  } = orderPrintingConfigService();

  const lang = useOrderPrintingConfigLang();
  const partnerId: PartnerId = useSelector(
    ({ partnerReducer }: any) => partnerReducer?.profile?.id,
  );

  const handleOnChangeAutoPrinting = (isChecked: boolean, canLog = true) => {
    _setState(ps => ({ ...ps, autoPrint: isChecked }));
    setOrderPrintingConfig({ ..._state, autoPrint: isChecked });
    if (canLog) {
      orderPrintingConfigAnalytic.logPrintSetup({
        ..._state,
        partnerId,
        autoPrint: isChecked,
      });
    }
  };

  const handleOnChangeChecklist = (isChecked: boolean, canLog = true) => {
    _setState(ps => ({ ...ps, checklist: isChecked }));
    setOrderPrintingConfig({ ..._state, checklist: isChecked });
    if (canLog) {
      orderPrintingConfigAnalytic.logPrintSetup({
        ..._state,
        partnerId,
        checklist: isChecked,
      });
    }
  };

  const handleOnCheckCommandPrinting = (isChecked: boolean, canLog = true) => {
    handleOnChangeAutoPrinting(false, false);
    handleOnChangeChecklist(isChecked, false);
    _setState(ps => ({ ...ps, command: isChecked }));
    setOrderPrintingConfig({
      command: isChecked,
      checklist: isChecked,
      autoPrint: false,
    });
    if (canLog) {
      orderPrintingConfigAnalytic.logPrintSetup({
        partnerId,
        command: isChecked,
        checklist: isChecked,
        autoPrint: false,
      });
    }
  };

  useEffect(() => {
    const printSetup = getOrderPrintingConfig();
    if (printSetup.command) _setState(printSetup);
    else handleOnCheckCommandPrinting(false, false);
  }, []);

  return {
    lang,
    isCommandPrinting: _state.command,
    isAutoPrinting: _state.autoPrint,
    isChecklist: _state.checklist,
    handleOnCheckCommandPrinting,
    handleOnChangeAutoPrinting,
    handleOnChangeChecklist,
  };
}
